import React from "react";
import { Users, CheckCircle2, DollarSign } from "lucide-react";
import { t } from "@/lib/i18n";

const fmtUSD = (n) => `$${(n || 0).toLocaleString("en-US")}`;
const fmtVND = (n) =>
  new Intl.NumberFormat("vi-VN", { maximumFractionDigits: 0 }).format(n || 0);

export default function StatsCards({ data, lang }) {
  if (!data) return null;
  const cards = [
    {
      key: "submitted",
      testid: "total-referrals-card",
      icon: Users,
      label: t(lang, "stats_submitted"),
      value: data.total_submitted,
      sub: `${data.total_contacted} ${t(lang, "status_contacted").toLowerCase()}`,
    },
    {
      key: "signed",
      testid: "total-signed-card",
      icon: CheckCircle2,
      label: t(lang, "stats_signed"),
      value: data.total_signed,
      sub: t(lang, "stats_signed_sub"),
    },
    {
      key: "earnings",
      testid: "total-earnings-card",
      icon: DollarSign,
      label: t(lang, "stats_earnings"),
      value: fmtUSD(data.earnings_usd),
      sub:
        lang === "vi"
          ? `${t(lang, "approx")} ₫${fmtVND(data.earnings_vnd_approx)}`
          : t(lang, "stats_earnings_sub"),
      highlight: true,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-6">
      {cards.map((c, i) => (
        <div
          key={c.key}
          data-testid={c.testid}
          className={`eigoo-card relative p-6 anim-fade-up anim-delay-${i + 1}`}
        >
          <div className="flex items-start justify-between">
            <div>
              <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-400">
                {c.label}
              </div>
              <div
                className={`font-display mt-3 text-3xl sm:text-4xl font-extrabold tracking-tight ${
                  c.highlight ? "gold-gradient-text" : "text-white"
                }`}
              >
                {c.value}
              </div>
              <div className="text-xs text-slate-400 mt-2">{c.sub}</div>
            </div>
            <div
              className={`w-11 h-11 rounded-xl grid place-items-center border ${
                c.highlight
                  ? "border-[#d4a843]/50 bg-[#d4a843]/10 text-[#f3c669]"
                  : "border-[#1e3a61] bg-[#0f2038] text-slate-300"
              }`}
            >
              <c.icon className="w-5 h-5" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
